import { css } from 'styled-components';

export const FONT_FAMILY_SANS = `'Suisse Intl', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
export const FONT_FAMILY_SERIF = `'Victor Serif', Georgia, 'Times New Roman', serif`;

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

/** Victor Serif is loaded at weight 500 only */
export const fontWeightSerif = {
  medium: 500,
} as const;

export const suisseIntl = (weight: number = fontWeight.regular) => css`
  font-family: ${FONT_FAMILY_SANS};
  font-weight: ${weight};
`;

export const victorSerif = (weight: number = fontWeightSerif.medium) => css`
  font-family: ${FONT_FAMILY_SERIF};
  font-weight: ${weight};
`;
